import { call, takeLatest } from 'redux-saga/effects';
import { EDTFSlice } from '@restore/EDTF/EDTF.slice';
import type { PayloadAction } from '@reduxjs/toolkit';
import { dispatch } from '@dynamika-shared/utils/saga';
import type { Resp } from '@restore/helpers';
import { fetchQCTaskUploadEdtf } from '@api/qcTask';

export function* fetchEDTFWorker(
  action: PayloadAction<{
    clinicalTrialId: string;
    taskId: string;
    uploadId: string;
  }>
) {
  try {
    const response: Resp<typeof fetchQCTaskUploadEdtf> = yield call(
      fetchQCTaskUploadEdtf,
      action.payload.clinicalTrialId,
      action.payload.taskId,
      action.payload.uploadId
    );
    yield dispatch(EDTFSlice.actions.fetchEDTFSuccess(response?.data));
  } catch (err) {
    yield dispatch(EDTFSlice.actions.fetchEDTFFailure(err as Error));
  }
}

export function* openEDTFWorker(
  action: PayloadAction<{
    clinicalTrialId: string;
    taskId: string;
    uploadId: string;
  }>
) {
  yield dispatch(EDTFSlice.actions.fetchEDTF(action.payload));
}
export function* EDTFSaga() {
  yield takeLatest(EDTFSlice.actions.fetchEDTF.type, fetchEDTFWorker);
  yield takeLatest(EDTFSlice.actions.openEDTF.type, openEDTFWorker);
}
